import PropTypes from 'prop-types';

export const FilterShape = PropTypes.shape({
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  openFilter: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
});
